import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BlogsDetails from "../blogdetails.js";
import BlogSidebar from "../blogSidebar.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function BlogWholeWheatVsMaida() {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleClick = () => {
    window.open("https://wheatbakes.com/", "_blank");
  };

  return (
    <Container className="blog-page mt-4">
      <Row>
        {/* Sidebar */}
        <Col md={1} className={`blog-sidebar ${showSidebar ? "show" : "hide"}`}>
          <BlogSidebar
            blogs={BlogsDetails}
            closeSidebar={() => setShowSidebar(!showSidebar)}
            active={"why-whole-wheat-cakes-are-healthier-than-maida-cakes"}
          />
        </Col>

        {/* Main Content */}
        <Col md={12} className="blog-content">
          {/* Toggle button for mobile */}
          <div
            onClick={() => setShowSidebar(!showSidebar)}
            className="blogs-sidebar-open mb-3"
          >
            <FontAwesomeIcon
              icon={faBars}
              className="blogs-sidebar-close-icon me-2"
            />
            View Other Blogs
          </div>

          {/* Blog Intro Section */}
          <div className="container row my-4">
            <div className="col-lg-6 col-xl-6 col-sm-12 my-2" data-aos="fade-left">
              <h2 className="brown-text-color text-bold-600">
                Why Whole Wheat Cakes Are Healthier Than Maida Cakes
              </h2>

              <p className="wheatbakes-para-justify">
                In recent years, health-conscious consumers have started
                questioning what goes into their desserts. Cakes, once considered
                an occasional indulgence, are now being reimagined with better
                ingredients and smarter choices. One of the biggest shifts in
                baking is the move from <span className="fw-semibold">maida cakes to whole wheat cakes.</span>
              </p>

              <p className="wheatbakes-para-justify">
                At <span className="fw-semibold">WheatBakes</span>, we believe you don’t have to compromise on
                taste to eat healthier. Let’s explore why <span className="fw-semibold">whole wheat cakes are
                healthier than maida cakes</span> and why making the switch can be one of
                the best decisions for your overall well-being.
              </p>
            </div>

            <div
              className="col-lg-6 col-xl-6 col-sm-12 my-2"
              data-aos="fade-right"
            >
              <img
                src={"/images/home/cupcake.jpg"}
                alt="Whole Wheat Cakes vs Maida Cakes"
                className="img-fluid rounded w-100"
              />
            </div>
          </div>

          {/* Section */}
          <h4 className="brown-text-color">
            Understanding the Difference: Whole Wheat vs Maida
          </h4>

          <h5 className="brown-text-color">What Are Maida Cakes?</h5>
          <p className="wheatbakes-para-justify">
            Maida (refined wheat flour) is made by removing the bran and germ from
            wheat grains, leaving behind only the starchy endosperm. This heavy
            processing strips away most of the natural fiber, vitamins, and
            minerals. As a result, <span className="fw-semibold">maida cakes:</span>
          </p>

          <ul>
            <li>Are low in fiber</li>
            <li>Have a high glycemic index</li>
            <li>Provide empty calories with little nutrition</li>
          </ul>

          <h5 className="brown-text-color">What Are Whole Wheat Cakes?</h5>
          <p className="wheatbakes-para-justify">
            Whole wheat flour is made by grinding the entire wheat grain — bran,
            germ, and endosperm — together. This means <span className="fw-semibold">whole wheat cakes </span>retain
            their natural nutrients and fiber, making them a much healthier
            alternative.
          </p>

          {/* Benefits */}
          <h4 className="brown-text-color">
            Key Health Benefits of Whole Wheat Cakes
          </h4>

          <h5 className="brown-text-color">1. Rich in Dietary Fiber</h5>
          <p className="wheatbakes-para-justify">
            One of the biggest advantages of <span className="fw-semibold">healthy whole wheat cakes</span> is their
            high fiber content. Fiber:
          </p>

          <ul>
            <li>Improves digestion</li>
            <li>Helps prevent constipation</li>
            <li>Keeps you fuller for longer</li>
          </ul>

          <p className="wheatbakes-para-justify">
            In contrast, <span className="fw-semibold">maida cakes</span> lack fiber and can lead to quick hunger and
            overeating.
          </p>

          <h5 className="brown-text-color">2. Better Blood Sugar Control</h5>
          <p className="wheatbakes-para-justify">
            Whole wheat flour has a <span className="fw-semibold">lower glycemic index</span> than maida. This means:
          </p>

          <ul>
            <li>Slower release of sugar into the bloodstream</li>
            <li>Reduced risk of sudden sugar spikes</li>
          </ul>

          <p className="wheatbakes-para-justify">
            This makes <span className="fw-semibold">maida-free cakes</span> a better choice for people managing
            diabetes, insulin resistance, or those simply trying to maintain
            stable energy levels throughout the day.
          </p>

          <h5 className="brown-text-color">3. More Nutrients, Less Processing</h5>
          <p className="wheatbakes-para-justify">
            Whole wheat cakes are naturally rich in:
          </p>

          <ul>
            <li>B vitamins</li>
            <li>Iron</li>
            <li>Magnesium</li>
            <li>Antioxidants</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Maida, on the other hand, is heavily processed and often bleached,
            removing most of these essential nutrients.
          </p>

          <h5 className="brown-text-color">4. Supports Heart Health</h5>
          <p className="wheatbakes-para-justify">
            Thanks to their fiber and nutrient profile, <span className="fw-semibold">whole wheat cakes</span> can
            help:
          </p>

          <ul>
            <li>Lower bad cholesterol (LDL)</li>
            <li>Improve heart health</li>
            <li>Reduce the risk of lifestyle-related diseases</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Switching from maida cakes to <span className="fw-semibold">healthy whole wheat cakes</span> is a small
            change that can make a long-term impact.
          </p>

          <h5 className="brown-text-color">5. No Compromise on Taste</h5>
          <p className="wheatbakes-para-justify">
            At <span className="fw-semibold">WheatBakes,</span> our expert baking techniques ensure that our <span className="fw-semibold">maida-free
            cakes </span>are:
          </p>

          <ul>
            <li>Soft and moist</li>
            <li>Naturally flavorful</li>
            <li>Just as indulgent as traditional cakes</li>
          </ul>

          <p className="wheatbakes-para-justify">
            Healthier does not mean boring — it means smarter.
          </p>

          {/* Why WheatBakes */}
          <h4 className="brown-text-color">
            Why Choose WheatBakes for Whole Wheat Cakes?
          </h4>

          <p className="wheatbakes-para-justify">
            At <span className="fw-semibold">WheatBakes</span>, we specialize in:
          </p>

          <ul>
            <li><span className="fw-semibold">100% maida-free cakes</span></li>
            <li>
              Carefully balanced recipes using whole wheat flour
            </li>
            <li>Eggless and healthier baking options</li>
            <li>
              Cakes that are perfect for daily consumption, celebrations, and
              guilt-free indulgence
            </li>
          </ul>

          <p className="wheatbakes-para-justify">
            Whether you’re looking for a birthday cake or a healthier dessert
            option, our <span className="fw-semibold">whole wheat cakes</span> are crafted to give you the best of
            both worlds <span className="fw-semibold">— taste and nutrition.</span>
          </p>

          <p className="wheatbakes-para-justify">
            Explore our collection of 
            {/* <br /> */}
            <a href="https://wheatbakes.com/" target="_blank" rel="noreferrer" style={{"color":"#1b1a1b"}}>
            <span className="fw-semibold"> healthy whole wheat cakes </span> 
            </a>
            here
          </p>

          {/* Final Thoughts */}
          <h4 className="brown-text-color">Final Thoughts</h4>
          <p className="wheatbakes-para-justify">
            While <span className="fw-semibold">maida cakes</span> may look tempting, their lack of nutrition and high
            sugar impact makes them less ideal for regular consumption. <span className="fw-semibold">Whole
            wheat cakes</span> offer a healthier, more balanced alternative without
            sacrificing taste.
          </p>

          <p className="wheatbakes-para-justify">
            If you’re ready to make a healthier switch, choose <span className="fw-semibold">maida-free cakes
            from <b>WheatBakes</b></span> — because every bite should nourish your body
            as well as delight your taste buds.
          </p>

          {/* CTA */}
          <div className="my-5 text-center">
            <button className="wheatbakes-btn" onClick={handleClick}>
              EXPLORE HEALTHY WHOLE WHEAT CAKES
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BlogWholeWheatVsMaida;
